export default "__VITE_ASSET__FXGuenos__"